import React, { useEffect } from 'react';
import '../../styles/tokens.css';
import './overlay.css';
import { FrontBackdrop } from './FrontBackdrop';
import { FrontDrawerPanel } from './FrontDrawerPanel';
import { FrontModalPanel } from './FrontModalPanel';
import { FrontOverlayPortal } from './FrontOverlayPortal';

export type FrontOverlayMode = 'drawer' | 'modal';

type Props = {
  open: boolean;
  mode?: FrontOverlayMode;
  onClose: () => void;
  children: React.ReactNode;
  panelClassName?: string;
};

export const FrontOverlay: React.FC<Props> = ({
  open,
  mode = 'drawer',
  onClose,
  children,
  panelClassName = '',
}) => {
  const normalizedMode: FrontOverlayMode = mode === 'modal' ? 'modal' : 'drawer';

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <FrontOverlayPortal>
      <div className={`ips-frontfw-overlay ips-frontfw-overlay--${normalizedMode}`}>
        <FrontBackdrop onClick={onClose} />
        {normalizedMode === 'modal' ? (
          <FrontModalPanel className={panelClassName}>{children}</FrontModalPanel>
        ) : (
          <FrontDrawerPanel className={panelClassName}>{children}</FrontDrawerPanel>
        )}
      </div>
    </FrontOverlayPortal>
  );
};
